import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"

export const sundayPollDeleteApi = createAsyncThunk(
    'auth/sundayPoll/delete',
    async (id, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.delete(apiRoutes.sundayPollsAction(`poll-delete/${id}`, 1))
            return response.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

const sundayPollDeleteSlice = createSlice({
    name: 'sundayPoll delete',
    initialState: { result: [], loading: false, error: null, message: "" },
    extraReducers: (builder) => {
        builder.addCase(sundayPollDeleteApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(sundayPollDeleteApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(sundayPollDeleteApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})

export const sundayPollDeleteReducer = sundayPollDeleteSlice.reducer